import React from "react";

const PageNotFound = () => {
    return(
        <>Page not found</>
    )
}
export default PageNotFound